import PropTypes from "prop-types"
import React, { useEffect } from "react"
import { Route, Switch, useHistory } from "react-router"
import styled from "styled-components"

import { useStateValue } from "../../_shared/context/AppStateStore"
import AdminAuthPage from "./AuthPage"
import AdminLoggedApp from "./LoggedApp"

// ----------------------------------------------------------------------------

function AdminApp(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { match } = props

    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    const [{ user }] = useStateValue()

    const history = useHistory()

    // -------------------------------------
    // Effects
    // -------------------------------------

    useEffect(() => {
        if (!user) return
        else if (user.role !== "admin") {
            history.push("/")
        }
        // eslint-disable-next-line
    }, [user])

    // -------------------------------------
    // Component functions
    // -------------------------------------

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    // ----------------------------------------------------------------------------

    return user ? (
        <Switch>
            <Route path={`${match.url}`} component={AdminLoggedApp}></Route>
        </Switch>
    ) : (
        <Switch>
            <Route path={`${match.url}`} component={AdminAuthPage}></Route>
        </Switch>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

AdminApp.propTypes = {
    className: PropTypes.string.isRequired,
    match: PropTypes.object,
}

AdminApp.defaultProps = {}

// ----------------------------------------------------------------------------

const StyledAdminApp = styled(AdminApp)`
    & {
    }
`
// ----------------------------------------------------------------------------

export default StyledAdminApp
